'use client';

import React, { FC } from 'react';
import { TypeNavItemFields } from '@/core/generated-types';
import { Link } from '@/navigation';
import { buildLinkUrl } from '@/utils/linkBuilder';
import classNames from 'classnames';
import {
  CLICKED_ITEM_TYPES,
  PAGE_LOCATIONS,
  trackItemClickedEvent,
} from '@/utils/rudderstack';
import useLocale from '@/hooks/useLocale';

interface NavItemProps extends TypeNavItemFields {
  onClose?: () => void;
}

export const NavItem: FC<NavItemProps> = ({
  badgeText,
  badgeColor,
  link,
  title,
  onClose,
}) => {
  const locale = useLocale();
  const href = buildLinkUrl(link, locale);

  const badgeColorClass =
    badgeColor?.fields?.color && `text-${badgeColor.fields.color}`;

  return (
    <Link
      href={href}
      data-testid="nav-item"
      className="flex items-center text-base md:text-sm md:py-1 py-2.5"
      onClick={() => {
        trackItemClickedEvent({
          type: CLICKED_ITEM_TYPES.LINK,
          cta: title,
          pageLocation: PAGE_LOCATIONS.NAVIGATION,
          url: window.location.href,
        });

        onClose?.();
      }}
    >
      <div className="text-charcoal-v2 font-normal flex-none lg:hover:text-blue-deep lg:hover:underline">
        {title}
      </div>

      {badgeText && (
        <div
          className={classNames('flex-none ml-2 font-bold', badgeColorClass)}
        >
          {badgeText}
        </div>
      )}
    </Link>
  );
};

export default React.memo(NavItem);
